/*
 * ZUUME — олон бараа нэг дор сагслах / шууд захиалах helper.
 * assets/zuume-buy-items.js
 *
 * Багц сонгогчид (zuume-pack-picker, zuume-mix-bundle) ашиглана.
 *   ZuumeBuyItems.addToCart([{ variant_id, quantity }]) -> Promise
 *   ZuumeBuyItems.buyNow([{ variant_id, quantity }])    -> checkout руу шилжинэ
 *
 * buyNow нь Shopify-н "Buy it now" шиг сагсанд хүрэхгүй. Ecomify checkout
 * routing (app embed) идэвхтэй бол түүний нийтэд нээлттэй
 * EcomifyCheckoutRouting функцүүдээр pay.ecomify.mn хаяг үүсгэнэ. Бусад бүх
 * тохиолдолд Shopify-н cart permalink (/cart/ID:тоо,...) нь мөн зөвхөн эдгээр
 * бараатай checkout нээдэг.
 */
(function () {
  if (window.ZuumeBuyItems) return;

  // Нэг вариантыг давхардуулахгүй нэгтгэнэ
  function merge(items) {
    var map = {};
    var order = [];
    items.forEach(function (i) {
      var id = parseInt(i.variant_id, 10);
      var q = parseInt(i.quantity, 10) || 0;
      if (!id || q <= 0) return;
      if (!map[id]) {
        map[id] = 0;
        order.push(id);
      }
      map[id] += q;
    });
    return order.map(function (id) {
      return { variant_id: id, quantity: map[id] };
    });
  }

  function addToCart(items) {
    var lines = merge(items).map(function (i) {
      return { id: i.variant_id, quantity: i.quantity };
    });
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines }),
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  var decision = null;
  function ecomifySettings() {
    var node = document.querySelector('[data-ecomify-checkout-routing]');
    if (!node || !window.EcomifyCheckoutRouting) return null;
    var s = {
      apiBaseUrl: node.getAttribute('data-api-base-url'),
      publicStoreId: node.getAttribute('data-public-store-id'),
      checkoutBaseUrl: node.getAttribute('data-checkout-base-url'),
      timeoutMs: Number(node.getAttribute('data-timeout-ms')) || undefined,
    };
    return s.apiBaseUrl && s.publicStoreId && s.checkoutBaseUrl ? s : null;
  }
  function ecomifyDecision() {
    if (decision) return decision;
    var s = ecomifySettings();
    // Skript хараахан ачаалагдаагүй бол кэшлэхгүй — дараагийн удаа дахин оролдоно
    if (!s) return Promise.resolve(null);
    decision = window.EcomifyCheckoutRouting.resolveDecision({
      fetch: window.fetch.bind(window),
      apiBaseUrl: s.apiBaseUrl,
      publicStoreId: s.publicStoreId,
      timeoutMs: s.timeoutMs,
      setTimeout: window.setTimeout.bind(window),
      clearTimeout: window.clearTimeout.bind(window),
    }).then(
      function (d) { return d === 'ECOMIFY_CUSTOM' ? s : null; },
      function () { return null; }
    );
    return decision;
  }

  // Ecomify-н init skripттэй ижил дүрмээр: зөвшөөрөл GRANTED үед л
  // хэрэглэгчийн зар сурталчилгааны мэдээлэл дамжина.
  function ecomifyAttribution(routing) {
    var consent = 'UNKNOWN';
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && privacy.marketingAllowed() === true) {
        consent = 'GRANTED';
      } else if (privacy && typeof privacy.currentVisitorConsent === 'function') {
        var v = privacy.currentVisitorConsent();
        if (v && v.marketing === 'no') consent = 'DENIED';
      }
    } catch (e) {}
    var stored = null;
    if (consent === 'GRANTED') {
      try {
        stored = JSON.parse(localStorage.getItem('ecomify:attribution:v1') || 'null');
      } catch (e) {}
    }
    try {
      return routing.buildAttribution({ consent: consent, cookie: document.cookie, stored: stored, nowMs: Date.now() });
    } catch (e) {
      return null;
    }
  }

  function buyNow(items) {
    var lines = merge(items);
    var native = '/cart/' + lines.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
    return ecomifyDecision().then(function (s) {
      var url = null;
      if (s) {
        var routing = window.EcomifyCheckoutRouting;
        url = routing.buildCheckoutUrl(s.checkoutBaseUrl, s.publicStoreId, routing.buildCartParam(lines), ecomifyAttribution(routing));
      }
      window.location.assign(url || native);
    });
  }

  // Шийдвэрийг урьдчилан авч, товч дарахад хүлээлгүй болгоно
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ecomifyDecision);
  } else {
    ecomifyDecision();
  }

  window.ZuumeBuyItems = { addToCart: addToCart, buyNow: buyNow };
})();
